import { createFileRoute } from '@tanstack/react-router'
import { SwapRecord } from '@/features/trade/swap/SwapRecord'

export const Route = createFileRoute('/_app/swap/logs')({
  component: SwapRecord,
})
